import * as React from 'react'
import { SystemBase } from '../../library/common/SystemBase';
import httpRequest from './../../service/httpService';
import { IDynamicList } from '../../library/types/IDynamicList'
import { ComboBox, ComboBoxFilterChangeEvent, ComboBoxProps, MultiColumnComboBox, MultiColumnComboBoxProps, MultiSelect as KendoMultiSelect, MultiSelectChangeEvent, MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { filterBy, FilterDescriptor } from '@progress/kendo-data-query';
import { getLookupValue } from '../../service/userService';

interface ISystemDropDownState {
    listItems?: any[],
    filteredItems?: any[],
    selectedItems?: any[],
    isLoading?: boolean,
    nextDataSource?: string,
    nextSearchText?: string,
    ref?: any,
}
export abstract class SystemBaseList<P = {}, S = {}> extends SystemBase<IDynamicList & P, ISystemDropDownState & S> {

    ref: any = null;
    constructor(props: any) {
        super(props)
        this.state = {
            ...this.state,
            listItems: [],
            filteredItems: [],
            selectedItems: [],
            isLoading: false,
            text: ''
        }
        this.ref = React.createRef();
    }
    static defaultProps = {
        ...SystemBase.defaultProps,
        autoDisable: true,
        isMultiColumn: false,
        fetchOnFilter: false,
        textField: "Text",
        dataItemKey: "Value",
        placeholder: "- Please Select -",
        className: "input_feild",
        minFilterLength: 3,
        columns: [],
        smartSearch: false,
        filterable: true,
        LookupName: ''
    } as IDynamicList;

    static cachePrefix = 'lib-lookup-';
    static cacheDataSet = (lookupname?: string, data?: any[]) => sessionStorage.setItem(`${SystemBaseList.cachePrefix}${lookupname}`, JSON.stringify(data))
    static cacheDataGet = (lookupname?: string) => JSON.parse(sessionStorage.getItem(`${SystemBaseList.cachePrefix}${lookupname}`) || '[]');

    idField: any = this.props.idField || this.props.dataItemKey || 'id';
    textField: any = this.props.displayField || this.props.textField || 'text';
    getValue = (item: any) => item && item[this.idField] || '';
    getText = (item: any) => item && item[this.textField] || '';
    separator: string = ',';

    getItem = (listItems: any, value: any): any => {
        var item: any | undefined = undefined;

        if (listItems && listItems.length > 0 && value != undefined && value != null)
            item = listItems.find((item: any) => item[this.idField] == value)

        return item;
    }

    setValue = (value: any, callback?: () => void) => {
        let item = this.getItem(this.state.filteredItems, value);
        this.setState({ valueObject: item, value: value }, callback);
        this.props.onTextChanged && this.props.onTextChanged(this.getText(item));
    }

    componentDidMount = () => {
        this.setupValidators();
        this.fetchData(this.props.dataSource, this.props.searchText)
    }

    async componentDidUpdate(prevProps: any) {
        if (prevProps.dataSource != this.props.dataSource || prevProps.searchText != this.props.searchText) {
            if (this.state.isLoading) {
                this.setState({ nextDataSource: this.props.dataSource, nextSearchText: this.props.searchText })
            }
            else await this.fetchData(this.props.dataSource, this.props.searchText)
        }
        this.handleDidUpdate(prevProps);
    }


    filterData = (filter: FilterDescriptor) => {
        return filterBy(this.state.listItems, filter);
    };

    setFocus = () => {
        console.log("ref", this.ref);

        this.ref.current.focus();
    }

    onFilterChange = async (event: ComboBoxFilterChangeEvent | MultiSelectFilterChangeEvent) => {
        let filter = { ...event.filter };
        if (this.props.smartSearch) {
            console.log('dropdown multi column event', event);
            if (this.props.minFilterLength && filter.value.length >= this.props.minFilterLength) {
                await this.fetchData(this.props.dataSource, filter.value)
                this.setFocus();
            }

            else {
                //this.fetchData(this.props.dataSource, '')
                this.setState({ listItems: [], filteredItems: [] });
                if (filter.value == "" || filter.value == undefined) {
                    this.handleChange(event, filter.value, event.target.name)
                }
            }

        } else {
            if (!this.props.minFilterLength || filter.value.length >= this.props.minFilterLength)
                this.setState({ filteredItems: this.filterData(filter) });
            else
                this.setState({ filteredItems: this.state.listItems });
        }
    }

    fetchData = async (datasource: any, filter?: string) => {
        var listItems: any[] = [];
        var response: any;
        this.setState({ isLoading: true })
        /** 
         * Sandeep: If lookupName is provided, get values from cache. 
         * Else call the api and get the values.
         * 
         */
        if (this.props.lookupName) {
            listItems = getLookupValue(this.props.lookupName);
        }
        else if (datasource) {
            try {
                if (filter && datasource.substr(datasource.length - 1, 1) == '?')
                    response = await httpRequest.get(datasource + "searchText=" + filter);
                else
                    response = await httpRequest.get(datasource + (filter ? ('/' + filter) : ''));
                    /**
                     *  Sandeep: set data or empty array, try to load kendo datasource first, then array, then empty array, 
                     *  also filters null and undefined text values
                     */
                
                listItems = (response.data.Data || response.data || []).filter((item: any, index: any, array: any) => {
                    let isNonEmpty = item[this.textField] != undefined && item[this.textField] != null
                    let isActive = (item["IsActive"] == undefined || item["IsActive"] == true)
                        && (item["Active"] == undefined || item["Active"] == true);

                    let isDistinct = (index === array.findIndex((f: any) => JSON.stringify(f) === JSON.stringify(item)));
                    return isNonEmpty && isActive && isDistinct
                });
            } catch (e) {
                listItems = [];
            }
        }
        // if there is any other data source in pipeline to be fetched 
        if (this.state.nextDataSource) {
            // to stop infinite loop we have to set nextdataSource to empty
            var nextDataSource = this.state.nextDataSource;
            this.setState({ nextDataSource: '' }, () => this.fetchData(nextDataSource));
        } else this.setState({ listItems: listItems || [], filteredItems: listItems || [] }, () => this.handleValueChange());
        this.setState({ isLoading: false })
    }

    getCurrentItemText = () => this.props.multiSelect
        ? (this.state.selectedItems ? this.state.selectedItems.map((items: any) => items[this.textField]).join(",") : '')
        : this.getText(this.getItem(this.state.listItems, this.props.value))


    handleValueChange = (validate?: boolean) => {
        let currItem = this.getItem(this.state.listItems, this.props.value)
        let selectedItems = this.props.multiSelect ? this.getItemsFromCSV(this.state.listItems, typeof this.props.value === 'string' && this.props.value || '') : [];
        let text = this.props.multiSelect
            ? selectedItems.map((items) => items[this.textField]).join(",")
            : this.getText(currItem)
        let value: any = this.props.allowCustom ? text : this.props.value

        //this.props.onChange && this.props.onChange(event, this.props.name, this.props.value, text);
        this.props.onAfterListUpdated && this.props.onAfterListUpdated(this.state.listItems, value, text)
        this.props.onTextChanged && this.props.onTextChanged(text);

        this.setState({ value: value, selectedItems }, () => validate && this.validate())
    }


    // for multi select
    getItemsFromCSV = (items: any[], value: string) => {
        let selectedItems: any[] = [];

        // create list of selected values
        if (typeof value === 'string' && value && value.split(this.separator).length > 0 && items && items.length > 0) {
            value.split(this.separator).map((id: any) => {
                let itemFound = items.find((t: any) => t[this.idField] == id);
                if (itemFound) selectedItems.push({ [this.idField]: itemFound[this.idField], [this.textField]: itemFound[this.textField] });
            })

        }
        return selectedItems;
    }

    // for multiselect
    getCSVFromItems = (items: any[]): string => {
        let result: string = "";
        items.map((item: any, index: any) => result += item[this.idField] + (index != items.length - 1 ? this.separator : ''));
        return result;
    }

    onMultiSelectChange = (event: MultiSelectChangeEvent) => {
        this.handleChange(event, this.getCSVFromItems(event.target.value), '');
    }

    handleDropDownChange = (event: any) => {
        this.handleChange(event, this.getValue(event.target.value), this.getText(event.target.value))

    }
}

export default class SystemDropDown extends SystemBaseList {
    constructor(props: any) {
        super(props)
    }

    render() {

        let multiSelect = this.props.multiSelect
        let multiColumn = !multiSelect && this.props.isMultiColumn && this.props.columns && this.props.columns.length > 0;
        let simpleDropDown = !multiSelect && !multiColumn;

        let isEmpty = !(this.state.filteredItems && this.state.filteredItems.length > 0)
        let isDisabled = this.props.disabled || this.state.isLoading;// || (!this.props.smartSearch && !this.props.multiSelect && this.props.autoDisable && isEmpty);
        let value = this.state.value == null || this.state.value == undefined || this.state.value == ''
            ? null
            : (this.props.multiSelect
                ? this.state.selectedItems
                : this.getItem(this.state.filteredItems, this.state.value));

        let text = ""
        try {
            text = this.props.smartSearch ? this.props.searchText : this.getCurrentItemText();
        } catch (e) {

        }


        return (
            <this.WrapperDiv title={text} multiSelect={multiSelect}>
                <span >
                    {
                        /* A MULTI SELECT SINGLE COLUMN DROP DOWN COMPONENT */
                        multiSelect &&
                        <KendoMultiSelect
                            disabled={isDisabled}
                            data={this.state.filteredItems}
                            onChange={this.onMultiSelectChange}
                            loading={this.state.isLoading}
                            onFilterChange={this.onFilterChange}
                            filterable={this.props.smartSearch || this.props.filterable}
                            label=""
                            //defaultValue={this.props.defaultValue}
                            dataItemKey={this.idField}
                            textField={this.textField}
                            onBlur={this.handleBlur} onFocus={this.handleFocus}
                            ref={this.ref}
                            value={this.state.selectedItems} />
                    }
                    {
                        /* A SINGLE SELECT MULTI COLUMN DROP DOWN COMPONENT */
                        multiColumn &&
                        <MultiColumnComboBox {...this.props as unknown as MultiColumnComboBoxProps}
                            data={this.state.filteredItems}
                            disabled={isDisabled}
                            onChange={this.handleDropDownChange}
                            loading={this.state.isLoading}
                            onFilterChange={this.onFilterChange}
                            filterable={this.props.smartSearch || this.props.filterable}
                            label=""
                            dataItemKey={this.idField}
                            textField={this.textField}
                            onBlur={this.handleBlur} onFocus={this.handleFocus}
                            ref={this.ref}
                            value={value}
                        />
                    }
                    {
                        /* A SINGLE SELECT SIMPLE DROP DOWN COMPONENT */
                        simpleDropDown &&
                        <ComboBox {...this.props as unknown as ComboBoxProps}
                            allowCustom={this.props.allowCustom}
                            data={this.state.filteredItems}
                            filterable={this.props.smartSearch || this.props.filterable}
                            disabled={isDisabled}
                            onChange={this.handleDropDownChange}
                            loading={this.state.isLoading}
                            onFilterChange={this.onFilterChange}
                            label=""
                            dataItemKey={this.idField}
                            textField={this.textField}
                            onBlur={this.handleBlur} onFocus={this.handleFocus}
                            ref={this.ref}
                            value={value} />
                    }
                </span>
            </this.WrapperDiv>
        );
    }
}

export const SmartSearch = (props: any) => <SystemDropDown {...props} smartSearch={true} />
export const MultiColumn = (props: any) => <SystemDropDown {...props} isMultiColumn={true} />
export const MultiSelect = (props: any) => <SystemDropDown {...props} multiSelect={true} />
